var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pdf',{attrs:{"src":this.pdfFile,"page":1}},[_c('template',{slot:"loading"},[_vm._v(" loading content here... ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }